import React, { useState, useEffect, useContext, useRef } from 'react';
import '../PlanerTura/PlanerTura.css';
import './Beleznica.css';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { ConfirmDialog } from 'primereact/confirmdialog';
import { AuthContext } from '../../Header/auth - context';
import { useSelector } from 'react-redux';
import BeleznicaDialog from './BeleznicaDialog';

const MONTHS = [
    { label: 'Januar', value: 1 }, { label: 'Februar', value: 2 }, { label: 'Mart', value: 3 },
    { label: 'April', value: 4 }, { label: 'Maj', value: 5 }, { label: 'Jun', value: 6 },
    { label: 'Jul', value: 7 }, { label: 'Avgust', value: 8 }, { label: 'Septembar', value: 9 },
    { label: 'Oktobar', value: 10 }, { label: 'Novembar', value: 11 }, { label: 'Decembar', value: 12 }
];
const DAY_SHORT = ['Pon', 'Uto', 'Sre', 'Čet', 'Pet', 'Sub', 'Ned'];
const DAY_FULL  = ['Ponedeljak', 'Utorak', 'Sreda', 'Četvrtak', 'Petak', 'Subota', 'Nedjelja'];

const getYearOptions = () => {
    const y = new Date().getFullYear();
    return [y - 1, y, y + 1].map(x => ({ label: String(x), value: x }));
};
const getDaysInMonth = (y, m) => new Date(y, m, 0).getDate();
const getMondayWeekday = (y, m, d) => { const js = new Date(y, m - 1, d).getDay(); return js === 0 ? 6 : js - 1; };
const buildWeeks = (year, month) => {
    const total = getDaysInMonth(year, month);
    const offset = getMondayWeekday(year, month, 1);
    const cells = Array(offset).fill(null);
    for (let d = 1; d <= total; d++) cells.push(d);
    while (cells.length % 7 !== 0) cells.push(null);
    const weeks = [];
    for (let i = 0; i < cells.length; i += 7) weeks.push(cells.slice(i, i + 7));
    return weeks;
};

const BeleznicaKalendar = () => {
    const auth    = useContext(AuthContext);
    const company = useSelector(s => s.company);
    const toast   = useRef(null);

    const now = new Date();
    const todayY = now.getFullYear(), todayM = now.getMonth() + 1, todayD = now.getDate();

    const [mesec,  setMesec]  = useState(todayM);
    const [godina, setGodina] = useState(todayY);
    const [calData, setCalData] = useState([]);
    const [selWeek, setSelWeek] = useState(null);

    const [statusiDB,  setStatusiDB]  = useState([]);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [editId,     setEditId]     = useState(null);

    const authHeaders = () => ({ 'Content-Type': 'application/json', Authorization: 'Bearer ' + auth.token });
    const handleErrors = r => { if (r.ok) return r.json(); throw r; };
    const call = (body) => fetch(process.env.REACT_APP_BACKEND_URL + '/beleznica/manage', {
        method: 'POST', headers: authHeaders(), body: JSON.stringify(body),
    }).then(handleErrors);

    const fetchCalendar = () => {
        call({ step: 'GET', mesec, godina })
            .then(data => setCalData(Array.isArray(data) ? data : []))
            .catch(() => {});
    };

    useEffect(() => {
        call({ step: 'INIT' })
            .then(data => setStatusiDB(JSON.parse(data[0].JsonOutput).StatusiDB || []))
            .catch(() => {});
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => { fetchCalendar(); /* eslint-disable-next-line */ }, [company, mesec, godina]);

    useEffect(() => {
        const weeks = buildWeeks(godina, mesec);
        if (godina === todayY && mesec === todayM) {
            const wi = weeks.findIndex(w => w.includes(todayD));
            setSelWeek(wi >= 0 ? wi : 0);
        } else setSelWeek(0);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [mesec, godina]);

    const openEdit = (entry) => { setEditId(entry.Izaberi); setDialogOpen(true); };

    // lookup po danu
    const lookup = {};
    calData.forEach(row => { const d = row.dan; if (!d) return; (lookup[d] = lookup[d] || []).push(row); });

    const weeks = buildWeeks(godina, mesec);
    const isToday = d => d && godina === todayY && mesec === todayM && d === todayD;
    const monthName = MONTHS.find(m => m.value === mesec)?.label || '';
    const prevMonth = () => { if (mesec === 1) { setMesec(12); setGodina(y => y - 1); } else setMesec(m => m - 1); };
    const nextMonth = () => { if (mesec === 12) { setMesec(1); setGodina(y => y + 1); } else setMesec(m => m + 1); };
    const currentWeek = selWeek !== null ? (weeks[selWeek] || weeks[0] || []) : (weeks[0] || []);

    const weekLabel = (() => {
        const days = currentWeek.filter(Boolean);
        if (!days.length) return '';
        return `${days[0]}. – ${days[days.length - 1]}. ${monthName} ${godina}`;
    })();

    const renderEvent = (entry, ei) => {
        const raw = entry.RokDisplay || '';
        const time = raw.indexOf(' ') !== -1 ? raw.slice(raw.indexOf(' ') + 1) : '';
        return (
            <div key={ei} className={`pk-event bel-cal-event${entry.Zavrseno ? ' bel-cal-event-done' : ''}`}
                onClick={() => openEdit(entry)} title={entry.tekst || ''}>
                <div className="bel-cal-ev-text">{entry.tekst}</div>
                <div className="pk-ev-row2">
                    {time && <span className="pk-ev-time">⏱ {time}</span>}
                    {entry.alarm ? <span className="bel-cal-ev-alarm"><i className="pi pi-bell" /></span> : null}
                    {entry.Status && <span className="bel-cal-ev-status">{entry.Status}</span>}
                </div>
            </div>
        );
    };

    return (
        <>
            <Toast ref={toast} />
            <ConfirmDialog />
            <BeleznicaDialog
                visible={dialogOpen}
                editId={editId}
                statusiDB={statusiDB}
                onHide={() => setDialogOpen(false)}
                onSaved={fetchCalendar}
                toast={toast}
            />

            <div className="pk-root">
                <div className="pk-controls">
                    <Button icon="pi pi-chevron-left" text onClick={prevMonth} className="pk-nav-btn" />
                    <span className="pk-month-label">{monthName} {godina}</span>
                    <Button icon="pi pi-chevron-right" text onClick={nextMonth} className="pk-nav-btn" />
                    <Dropdown value={mesec} options={MONTHS} onChange={e => setMesec(e.value)} className="pk-dropdown" style={{ width: '120px' }} />
                    <Dropdown value={godina} options={getYearOptions()} onChange={e => setGodina(e.value)} className="pk-dropdown" style={{ width: 'fit-content' }} />
                    <Button icon="pi pi-refresh" text onClick={fetchCalendar} className="pk-nav-btn" tooltip="Osveži" tooltipOptions={{ position: 'bottom' }} />
                    {weekLabel && <span className="pk-week-label">Nedelja: {weekLabel}</span>}
                </div>

                <div className="pk-body">
                    {/* LEFT mini calendar */}
                    <div className="pk-mini-cal">
                        <table className="pk-mini-table">
                            <thead>
                                <tr>{DAY_SHORT.map((lbl, i) => <th key={i} className={i >= 5 ? 'pk-mini-th pk-mini-th-we' : 'pk-mini-th'}>{lbl}</th>)}</tr>
                            </thead>
                            <tbody>
                                {weeks.map((week, wi) => (
                                    <tr key={wi} className={wi === selWeek ? 'pk-mini-row pk-mini-row-sel' : 'pk-mini-row'} onClick={() => setSelWeek(wi)}>
                                        {week.map((d, di) => {
                                            const isWe = di >= 5, isTd = isToday(d), hasEv = d && lookup[d]?.length > 0;
                                            let cls = 'pk-mini-td';
                                            if (!d) cls += ' pk-mini-td-empty';
                                            if (isWe) cls += ' pk-mini-td-we';
                                            return (
                                                <td key={di} className={cls}>
                                                    <span className={isTd ? 'pk-mini-day pk-mini-day-today' : 'pk-mini-day'}>{d || ''}</span>
                                                    {hasEv && <span className="pk-mini-dot" />}
                                                </td>
                                            );
                                        })}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    {/* RIGHT weekly detail — jedan red beleški po danu.
                        .pk-week-scroll (overflow:auto) omogućava horizontalni skrol svih 7 dana na mobile. */}
                    <div className="pk-week-panel">
                      <div className="pk-week-scroll">
                        <div className="pk-week-grid" style={{ gridTemplateRows: 'auto minmax(0, 1fr)', gridTemplateColumns: 'repeat(7, minmax(0, 1fr))' }}>
                            {currentWeek.map((d, di) => {
                                const isWe = di >= 5, isTd = isToday(d);
                                let cls = 'pk-wg-th';
                                if (isWe) cls += ' pk-week-th-we';
                                if (isTd) cls += ' pk-week-th-today';
                                const cnt = d ? (lookup[d]?.length || 0) : 0;
                                return (
                                    <div key={`h${di}`} className={cls}>
                                        {d ? <><span className="pk-wh-day">{d}.</span><span className="pk-wh-name">{DAY_FULL[di]}</span></>
                                          : <span className="pk-wh-name">{DAY_FULL[di]}</span>}
                                        {cnt > 0 && <span className="pk-wh-cnt">{cnt}</span>}
                                    </div>
                                );
                            })}
                            {currentWeek.map((d, di) => {
                                const entries = d ? (lookup[d] || []) : [];
                                const isWe = di >= 5;
                                return (
                                    <div key={`c${di}`} className={`pk-wg-cell${isWe ? ' pk-week-td-we' : ''}`}>
                                        {entries.map((entry, ei) => renderEvent(entry, ei))}
                                    </div>
                                );
                            })}
                        </div>
                      </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default BeleznicaKalendar;
